import { useEffect, useState } from "react";
import { fetchFPLData, fetchTransfersData } from "../api/fplApi";

const TopTransfersIn = ({ compact = false }) => {
  const [players, setPlayers] = useState([]);
  const [teams, setTeams] = useState([]);
  useEffect(() => {
    Promise.all([fetchFPLData(), fetchTransfersData()]).then(([fpl, transfers]) => {
      if (fpl) setTeams(fpl.teams || []);
      if (transfers) setPlayers([...transfers].sort((a, b) => b.transfers_in_event - a.transfers_in_event).slice(0, compact ? 3 : 5));
    }).catch(() => {});
  }, [compact]);
  const pos = {1:"GKP",2:"DEF",3:"MID",4:"FWD"};
  return (
    <div className="fpl-transfer-card is-in">
      <div className="fpl-transfer-title"><span>Transfers In</span><span>IN</span></div>
      {!players.length ? <div className="fpl-empty">Loading transfer data…</div> : players.map((p, i) => {
        const t = teams.find((x) => x.id === p.team);
        return <div className="fpl-transfer-row" key={p.id}>
          <span className="fpl-transfer-rank">{i + 1}</span>
          <img src={`https://fantasy.premierleague.com/dist/img/shirts/standard/shirt_${t?.code || p.team_code}-220.webp`} alt="" />
          <div className="min-w-0 flex-1"><div className="font-bold truncate">{p.web_name}</div><div className="text-[11px] text-slate-400">{t?.short_name || "—"} · {pos[p.element_type]}</div></div>
          <div className="fpl-transfer-number">+{Number(p.transfers_in_event || 0).toLocaleString()}</div>
        </div>;
      })}
    </div>
  );
};
export default TopTransfersIn;
